module.exports = __webpack_public_path__ + "img/QUEL_depth_V2_top_sm.8546ed5a.webp";